export default "__VITE_ASSET__9g5f6sxX__"